import { render, staticRenderFns } from "./face-img.vue?vue&type=template&id=a04921a2&"
import script from "./face-img.vue?vue&type=script&lang=js&"
export * from "./face-img.vue?vue&type=script&lang=js&"
import style0 from "./face-img.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a04921a2')) {
      api.createRecord('a04921a2', component.options)
    } else {
      api.reload('a04921a2', component.options)
    }
    module.hot.accept("./face-img.vue?vue&type=template&id=a04921a2&", function () {
      api.rerender('a04921a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/face-img/face-img.vue"
export default component.exports